<template>
    <v-parallax src="@/assets/pusha.jpg" class="pa-0 ma-0">
      <div class="my-title"> Миша, все-таки пуща водица намного лучше лысой горы</div>
    </v-parallax>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.my-title {
    font-family: 'Pacifico', cursive;
    font-size: 3rem;
  }
</style>